import { useCallback, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { loadCateringAccessRequest } from './cateringAccessActions';

/** The signed-in employee's Catering permissions. `load` reads them again (every page visit). */
export function useCateringAccess() {
  const dispatch = useAppDispatch();
  const access = useAppSelector((s) => s.catering.access);
  const load = useCallback(() => dispatch(loadCateringAccessRequest()), [dispatch]);
  return useMemo(() => ({ ...access, load }), [access, load]);
}
